import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { MapboxInputFilter } from "@circle-react-shared/Filter/FilterTypes/MapboxInputFilter";
import type { MapBoxFilterParams } from "@circle-react-shared/Filter/FilterTypes/MapboxInputFilter";
import { Filter } from "@circle-react-shared/FilterV3";
import type { BaseFilter } from "../types";

const localeNamespace = "members_directory.header.search.filters.geo_location";

export interface GeoLocationFilterProps {
  isInitialOpen?: boolean;
  onApply: (value: BaseFilter | null) => void;
  param: MapBoxFilterParams;
}

export const renderGeoLocationFilterValue = (param: MapBoxFilterParams) => {
  // For backwards compatability where old location filter was a string, we need to have the fallback
  if (typeof param.value === "string") {
    return param.value;
  }

  return param?.value?.name ?? "";
};

export const GeoLocationFilter = ({
  isInitialOpen = false,
  onApply,
  param,
}: GeoLocationFilterProps) => {
  const FilterChip = useMemo(
    () => (
      <Filter.Chip
        renderSelectedValue={() => renderGeoLocationFilterValue(param) || ""}
      >
        {t([localeNamespace])}
      </Filter.Chip>
    ),
    [param],
  );

  return (
    <Filter
      onApply={value => {
        onApply?.(value);
      }}
    >
      {FilterChip}
      <Filter.Popover
        title={t([localeNamespace])}
        isInitialOpen={isInitialOpen}
      >
        <MapboxInputFilter name="geo_location" param={param} />
      </Filter.Popover>
    </Filter>
  );
};
